import { ServiceHandler } from '../../utils';
import type { ProofOfLossView } from './responses/ProofOfLossResponses';

const BASE = '/api/claimsmgmt/v1/flow/proof-of-loss/:claimId/:lossItemId';

/** Called with the insured's flow token. The view holds only what the insured may see. */
export const getProofOfLoss = ServiceHandler<never, ProofOfLossView>({
  url: BASE,
});

/** One file per checklist item, as multipart part "file". Answers with the refreshed view. */
export const uploadProofOfLossDocument = ServiceHandler<
  FormData,
  ProofOfLossView
>({
  url: `${BASE}/:key`,
  method: 'POST',
});
